// pages/Devices/deviceconfigmodal.jsx
import React from 'react';

const DeviceConfigModal = ({ 
  isOpen, 
  onClose, 
  device, 
  configData, 
  loading, 
  searchTerm, 
  onSearchChange 
}) => {
  if (!isOpen) return null;

  // Format config data for display
  const getConfigItems = () => {
    if (!configData || !Array.isArray(configData)) return [];
    
    let items = configData;
    
    // Filter by search term
    if (searchTerm) {
      const searchLower = searchTerm.toLowerCase();
      items = configData.filter(item => 
        item.devid?.toLowerCase().includes(searchLower) ||
        item.params?.toLowerCase().includes(searchLower) ||
        item.updatedtime?.toLowerCase().includes(searchLower)
      );
    }
    
    return items;
  };

  const configItems = getConfigItems();

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="config-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Device Configuration</h3>
          <h4 style={{ fontSize: '14px', color: '#666', marginTop: '5px' }}>
            Device: {device?.deviceId || device?.cbid}
          </h4>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>
        
        <div className="config-search-bar">
          <input
            type="text"
            className="config-search-input"
            placeholder="Search by Device ID, Params, or Updated Time..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
          />
          {searchTerm && (
            <button className="config-clear-btn" onClick={() => onSearchChange('')}>
              ✕
            </button>
          )}
        </div>
        
        <div className="config-modal-body">
          {loading ? (
            <div className="config-loading">
              <div className="loading-spinner"></div>
              <p>Loading configuration data...</p>
            </div>
          ) : !configData || configData.length === 0 ? (
            <div className="config-empty">
              <p>No configuration data available for this device.</p>
            </div>
          ) : (
            <div className="config-table-container">
              <table className="config-table">
                <thead>
                  <tr>
                    <th>Device ID</th>
                    <th>Parameters</th>
                    <th>Updated Time</th>
                  </tr>
                </thead>
                <tbody>
                  {configItems.map((item, index) => (
                    <tr key={index}>
                      <td className="config-devid">{item.devid || '-'}</td>
                      <td className="config-params">
                        <pre className="config-params-pre">
                          {typeof item.params === 'object' 
                            ? JSON.stringify(item.params, null, 2) 
                            : item.params || '-'}
                        </pre>
                      </td>
                      <td className="config-time">
                        {item.updatedtime ? new Date(item.updatedtime).toLocaleString() : '-'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
        
        <div className="modal-footer">
          <button className="cancel-btn" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeviceConfigModal;